import { Component, signal } from "@angular/core";
import { GeocodeService } from "../../../services/data/geocode.service";
import { GeoItemResource } from "../../../models/igeo.interface";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
  selector: "app-select-geo-conference-dialog",
  standalone: false,
  templateUrl: "./select-geo-conference-dialog.component.html",
  styleUrl: "./select-geo-conference-dialog.component.css",
})
export class SelectGeoConferenceDialogComponent {
  cities = signal<GeoItemResource[]>([]);
  selectedCityId = signal<number | null>(null);
  selectedCity = signal<GeoItemResource | null>(null);

  constructor(
    private geoService: GeocodeService,
    private dialogRef: DynamicDialogRef
  ) {}

  onCityFilter(event: any) {
    const filter = event.filter || "";
    this.loadCities(filter);
  }

  loadCities(filter: string = "") {
    this.geoService.getCities(filter).subscribe({
      next: (data) => this.cities.set(data),
      error: (error) => {
        console.error("Error loading cities:", error);
      },
    });
  }

  onCityChange() {
    const cityId = this.selectedCityId();
    if (cityId) {
      const city = this.cities().find((c) => c.cityId === cityId);
      this.selectedCity.set(city || null);
    } else {
      this.selectedCity.set(null);
    }
  }
  onCancel() {
    this.dialogRef.close({ submitted: false });
  }

  onSave() {
    if (this.selectedCity()) {
      this.dialogRef.close({
        submitted: true,
        data: this.selectedCity(),
      });
    }
  }
}
